import type { FreelancerProfile, FreelancerReview } from '@/mocks/freelancers';

export interface FreelancerProfileDbRow {
  id: string;
  owner_id: string;
  display_name: string | null;
  headline: string | null;
  bio: string | null;
  skills: string | null;
  avatar_url: string | null;
  location: string | null;
  phone: string | null;
  website: string | null;
  created_at: string | null;
}

export interface FreelancerReviewDbRow {
  id: string;
  freelancer_id: string;
  user_id: string;
  rating: number;
  comment: string | null;
  status: string | null;
  created_at: string | null;
}

export function mapDbFreelancerProfile(row: FreelancerProfileDbRow): FreelancerProfile {
  return {
    id: row.id,
    ownerId: row.owner_id,
    displayName: row.display_name || 'Freelance',
    headline: row.headline || '',
    bio: row.bio || '',
    skills: row.skills || '',
    avatarUrl: row.avatar_url || '',
    location: row.location || 'À distance',
    phone: row.phone || '',
    website: row.website || '',
    memberSince: row.created_at ? row.created_at.slice(0, 4) : '',
  };
}

export function mapDbFreelancerReview(
  row: FreelancerReviewDbRow,
  reviewerName: string,
  reviewerInitials: string,
): FreelancerReview {
  return {
    id: row.id,
    reviewerName,
    reviewerInitials,
    rating: Number(row.rating),
    comment: row.comment || '',
    date: row.created_at ? row.created_at.slice(0, 10) : '',
  };
}

export function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function splitSkills(skills: string): string[] {
  return skills
    .split(/[,;]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function averageRating(reviews: FreelancerReview[]): number | null {
  if (reviews.length === 0) return null;
  const sum = reviews.reduce((acc, r) => acc + r.rating, 0);
  return Math.round((sum / reviews.length) * 10) / 10;
}

export function formatReviewDate(date: string): string {
  if (!date) return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  return d.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
}